import React, { useEffect, useState } from 'react';
import { ShoppingCart, CheckCircle } from 'lucide-react';
const NAMES = ['Sarah M. from Texas', 'James R. from Florida', 'Linda P. from California', 'Robert G. from Ohio', 'Patricia T. from New York', 'Michael L. from Arizona', 'Jennifer F. from Washington', 'David C. from Colorado', 'Maria B. from Illinois', 'William H. from Georgia', 'Karen D. from Michigan', 'Richard N. from Pennsylvania', 'Susan V. from Oregon', 'Thomas S. from Virginia', 'Nancy J. from North Carolina', 'Christopher K. from Tennessee', 'Betty W. from Minnesota', 'Daniel Z. from Nevada', 'Margaret A. from Indiana', 'Paul E. from Wisconsin', 'Dorothy O. from Missouri', 'Mark I. from Maryland', 'Sandra U. from Connecticut', 'Steven Y. from Alabama', 'Ashley Q. from Louisiana', 'Andrew X. from Kentucky', 'Emily P. from Iowa', 'Joshua R. from Oklahoma', 'Amanda L. from Utah', 'Kevin M. from Arkansas'];
type NotificationType = 'sale' | 'cart';
interface NotificationData {
  name: string;
  type: NotificationType;
  minutesAgo: number;
  id: number;
}
export function SaleNotifications() {
  const [notification, setNotification] = useState<NotificationData | null>(null);
  const [availableNames, setAvailableNames] = useState<string[]>([...NAMES]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let notificationCountInCycle = 0;
    let isWaiting = false;
    const showNotification = () => {
      if (isWaiting) return;
      let currentNames = availableNames;
      if (currentNames.length === 0) {
        currentNames = [...NAMES];
      }
      const nameIndex = Math.floor(Math.random() * currentNames.length);
      const name = currentNames[nameIndex];
      const newAvailableNames = [...currentNames];
      newAvailableNames.splice(nameIndex, 1);
      setAvailableNames(newAvailableNames);
      const type: NotificationType = Math.random() > 0.5 ? 'sale' : 'cart';
      const minutesAgo = Math.floor(Math.random() * 14) + 1; // 1–15 min ago
      setNotification({
        name,
        type,
        minutesAgo,
        id: Date.now()
      });
      setTimeout(() => {
        setNotification(null);
      }, 4000);
      notificationCountInCycle++;
      if (notificationCountInCycle < 4) {
        timeoutId = setTimeout(showNotification, 5000);
      } else {
        isWaiting = true;
        notificationCountInCycle = 0;
        timeoutId = setTimeout(() => {
          isWaiting = false;
          showNotification();
        }, 60000);
      }
    };
    timeoutId = setTimeout(showNotification, 9000);
    return () => clearTimeout(timeoutId);
  }, []);
  if (!notification) return null;
  return <div className={`fixed bottom-[70px] left-[12px] z-[1000] transition-all duration-500 ease-in-out transform ${notification ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`} data-id="element-312">
      <div className="bg-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-3 max-w-[280px] border border-gray-100" data-id="element-313">
        <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${notification.type === 'sale' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'}`} data-id="element-314">
          {notification.type === 'sale' ? <CheckCircle size={18} data-id="element-315" /> : <ShoppingCart size={18} data-id="element-316" />}
        </div>
        <div data-id="element-317">
          <p className="text-[12px] font-bold text-[#111827] leading-tight" data-id="element-318">
            {notification.name}
          </p>
          <p className="text-[11px] text-gray-500 leading-tight mt-0.5" data-id="element-319">
            {notification.type === 'sale' ? 'just downloaded the method' : 'added the method to cart'}
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-320">
            {notification.minutesAgo} min ago
          </p>
        </div>
      </div>
    </div>;
}